export default __webpack_public_path__ + "static/media/28.4e3d4fd4.jpg";